import { render } from "./ExchangeRates.vue?vue&type=template&id=ba53f650&scoped=true"
import script from "./ExchangeRates.vue?vue&type=script&lang=js"
export * from "./ExchangeRates.vue?vue&type=script&lang=js"

import "./ExchangeRates.vue?vue&type=style&index=0&id=ba53f650&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba53f650"]])

export default __exports__